import React, { useState, useEffect } from "react"
// import PdfViewer from "./../PdfViewver"

// function ViewTab({ fax, selectedFax, pdfUrl, loading }) {
//   return (
//     <div>
//       {fax.image ? (
//         <PdfViewer pdfUrl={pdfUrl} />
//       ) : loading ? (
//         <div className="loading-container">
//           <div className="loading-pdf-message">Loading ...</div>
//         </div>
//       ) : (
//         <p>
//           {selectedFax?.efaxStatus === "INPROGRESS"
//             ? "PDF not available as efax status is INPROGRESS"
//             : "PDF not available"}
//         </p>
//       )}
//     </div>
//   )
// }

// export default ViewTab

const ViewTab = ({ base64String, selectedFax, loading }) => {
  const [pdfUrl, setPdfUrl] = useState(null)

  useEffect(() => {
    if (base64String) {
      try {
        // Decode Base64 to binary data
        const byteCharacters = atob(base64String)
        const byteNumbers = new Array(byteCharacters.length)
          .fill()
          .map((_, i) => byteCharacters.charCodeAt(i))
        const byteArray = new Uint8Array(byteNumbers)

        // Create a Blob from binary data
        const blob = new Blob([byteArray], { type: "application/pdf" })

        // Generate a URL for the Blob
        const url = URL.createObjectURL(blob) + "#toolbar=0"
        setPdfUrl(url)

        return () => URL.revokeObjectURL(url) // Cleanup URL on unmount
      } catch (error) {
        console.error("Error processing PDF:", error)
      }
    }
  }, [base64String])

  return (
    <div style={{ flex: 1, display: "flex", flexDirection: "column" }}>
      {loading ? (
        <div className="loading-container">
          <div className="loading-pdf-message">Loading ...</div>
        </div>
      ) : base64String ? (
        <iframe
          src={pdfUrl}
          width="100%"
          height="100%"
          title="PDF Viewer"
          style={{
            flex: 1,
            width: "100%",
            border: "none",
          }}
        />
      ) : (
        <p>
          {selectedFax?.efaxStatus === "INPROGRESS"
            ? "PDF not available as efax status is INPROGRESS"
            : "PDF not available"}
        </p>
      )}
    </div>
  )
}

export default ViewTab
